'use client';

import TextField from '@haaretz/s-text-field';
import React from 'react';
import s9 from 'style9';

import type { TextFieldProps } from '@haaretz/s-text-field';

export type State = 'default' | 'invalid' | 'empty';

// `c` is short for `classNames`
const c = s9.create({
  field: {
    height: 'max-content',
    width: '100%',
  },
});

type RequiredFieldProps = TextFieldProps &
  React.RefAttributes<HTMLInputElement> & {
    inputState: State;
    setInputState: React.Dispatch<React.SetStateAction<State>>;
  };

function RequiredField({
  styleExtend = [],
  onInput,
  description,
  inputState,
  setInputState,
  ref,
  onBlur,
  ...props
}: RequiredFieldProps) {
  return (
    <TextField
      type="text"
      {...props}
      description={description}
      isInvalid={inputState !== 'default'}
      required
      onInput={event => {
        if (inputState !== 'default') {
          setInputState('default');
        }

        if (typeof onInput === 'function') {
          onInput(event);
        }
      }}
      onBlur={event => {
        let state: State = 'default';

        if (!event.currentTarget.value) {
          state = 'empty';
        } else if (!event.currentTarget.validity.valid) {
          state = 'invalid';
        }

        setInputState(state);

        if (typeof onBlur === 'function') {
          onBlur(event);
        }
      }}
      styleExtend={[c.field, ...styleExtend]}
      onInvalid={e => {
        e.preventDefault();

        setInputState(e.currentTarget.value ? 'invalid' : 'empty');
      }}
      ref={ref}
    />
  );
}

export default RequiredField;
